import API from "../utilities/LocalApiProxy";
import {
	OPEN_GLOBAL_SNACKBAR,
	UPDATE_FIRM_NAME_SUCCESS,
	GET_FIRM_INFO_SUCCESS,
	UPDATE_FIRM_INFO_FIELD_SUCCESS,
	FETCH_OFFICE_BRANCH_SUCCESS,
} from "./types";
export function getEWSUrl() {
	return function (dispatch) {
		dispatch({ type: "GET_EWS_URL_REQUEST" });
		API.get("/ews/exchangeServer")
			.then((res) => {
				dispatch({
					type: "GET_EWS_URL_SUCCESS",
					payload: res.mysql[0].exchangeUrl || "",
				});
			})
			.catch(() => {
				dispatch({ type: "GET_EWS_URL_FAILURE" });
			});
	};
}
export function setEWSUrl(exchangeUrl) {
	return function (dispatch) {
		dispatch({ type: "SET_EWS_URL_REQUEST" });
		API.post("/ews/exchangeServer", { body: { exchangeUrl } })
			.then(() => {
				dispatch({ type: "SET_EWS_URL_SUCCESS" });
				window.globalHistory.push("/settings");
			})
			.catch(() => {
				dispatch({ type: "SET_EWS_URL_FAILURE" });
			});
	};
}
export function unmountEWSPage() {
	return function (dispatch) {
		dispatch({ type: "UNMOUNT_EWS_PAGE" });
	};
}

export function updateFirmName(name) {
	return function (dispatch) {
		return API.post("/firm/updateName", { body: { name } })
			.then((res) => {
				dispatch({
					type: UPDATE_FIRM_NAME_SUCCESS,
					payload: { firmName: res.mysql.name },
				});
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						variant: "success",
						message: "Firm Display Name updated",
					},
				});
			})
			.catch((error) => {
				// LexWorkplace API errors (invalid name, insufficient permissions) show their own toast
				throw error;
			});
	};
}

// single consolidated fetch for the My Firm page: firm name, firm info, and locations
export function getMyFirmData() {
	return function (dispatch) {
		return API.get("/myFirm").then((res) => {
			const { firmName, firmInfo, officeBranches } = res.mysql;
			dispatch({
				type: UPDATE_FIRM_NAME_SUCCESS,
				payload: { firmName },
			});
			dispatch({
				type: GET_FIRM_INFO_SUCCESS,
				payload: firmInfo,
			});
			dispatch({
				type: FETCH_OFFICE_BRANCH_SUCCESS,
				payload: { tags: officeBranches },
			});
		});
	};
}

export function getFirmInfo() {
	return function (dispatch) {
		return API.get("/firm/info").then((res) => {
			dispatch({
				type: GET_FIRM_INFO_SUCCESS,
				payload: res.mysql,
			});
		});
	};
}

export function updateFirmInfoField(fieldName, value) {
	return function (dispatch) {
		return API.post("/firm/info", { body: { fieldName, value } })
			.then((res) => {
				dispatch({
					type: UPDATE_FIRM_INFO_FIELD_SUCCESS,
					payload: res.mysql,
				});
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						variant: "success",
						message: "Firm information updated",
					},
				});
			})
			.catch((error) => {
				// LexWorkplace API errors (insufficient permissions) show their own toast
				throw error;
			});
	};
}

const firmAdminEditableFeatures = [
	"clioIntegration",
	"literaDocumentCompareVisible",
];

export function getIntegrationSettings() {
	return function (dispatch) {
		API.get("/integrations/settings").then((res) => {
			dispatch({
				type: "GET_INTEGRATION_SETTINGS_SUCCESS",
				payload: res.mysql,
			});
		});
	};
}

export function getVersionControlSettings() {
	return function (dispatch) {
		API.get("/settings/versionControlSettings").then((res) => {
			dispatch({
				type: "GET_VERSION_CONTROL_SETTINGS_SUCCESS",
				payload: res.mysql,
			});
		});
	};
}

export function setVersionControlSettings({ featureValue }) {
	return function (dispatch) {
		dispatch({ type: "SET_VERSION_CONTROL_SETTINGS_REQUEST" });
		const status = featureValue ? 1 : 0;
		return API.post("/settings/versionControlSettings", {
			body: {
				featureCode: "manualVersioning",
				status,
			},
		})
			.then(() => {
				dispatch({
					type: "SET_VERSION_CONTROL_SETTINGS_SUCCESS",
					payload: { status },
				});
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						variant: "success",
						message: "Version Control mode updated",
					},
				});
			})
			.catch((error) => {
				dispatch({ type: "SET_VERSION_CONTROL_SETTINGS_FAILURE" });
				throw error;
			});
	};
}

export function getSharePasswordSettings() {
	return function (dispatch) {
		API.get("/settings/sharePasswordSettings").then((res) => {
			dispatch({
				type: "GET_SHARE_PASSWORD_SETTINGS_SUCCESS",
				payload: res.mysql,
			});
		});
	};
}

export function setSharePasswordSettings({ featureValue }) {
	return function (dispatch) {
		dispatch({ type: "SET_SHARE_PASSWORD_SETTINGS_REQUEST" });
		const status = featureValue ? 1 : 0;
		return API.post("/settings/sharePasswordSettings", {
			body: {
				featureCode: "externalShareIsPasswordProtected",
				status,
			},
		})
			.then(() => {
				dispatch({
					type: "SET_SHARE_PASSWORD_SETTINGS_SUCCESS",
					payload: { status },
				});
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						variant: "success",
						message:
							"External share password protection setting updated",
					},
				});
			})
			.catch((error) => {
				dispatch({ type: "SET_SHARE_PASSWORD_SETTINGS_FAILURE" });
				throw error;
			});
	};
}

export function setIntegrationSettings({ featureCode, featureValue }) {
	return function (dispatch) {
		dispatch({ type: "SET_INTEGRATION_SETTINGS_REQUEST" });

		if (!firmAdminEditableFeatures.includes(featureCode)) {
			console.error(`Invalid feature code: ${featureCode}`);
			dispatch({
				type: OPEN_GLOBAL_SNACKBAR,
				payload: {
					variant: "error",
					message: `Invalid feature code: ${featureCode}`,
				},
			});

			return new Promise((resolve, reject) => {
				setTimeout(() => {
					dispatch({
						type: "SET_INTEGRATION_SETTINGS_FAILURE",
						payload: {
							featureCode,
							status: featureValue ? 0 : 1,
						},
					});
					reject(new Error(`Invalid feature code: ${featureCode}`));
				}, 1000);
			});
		}

		const status = featureValue ? 1 : 0;
		return API.post("/integrations/settings", {
			body: {
				featureCode,
				status,
			},
		})
			.then(() => {
				dispatch({
					type: "SET_INTEGRATION_SETTINGS_SUCCESS",
					payload: { featureCode, status },
				});
			})
			.catch((error) => {
				dispatch({
					type: "SET_INTEGRATION_SETTINGS_FAILURE",
					payload: { featureCode },
				});
				throw error;
			});
	};
}
